export const DISPLAY_IMAGE = 0;
export const DISPLAY_DROPZONE = 1;
export const DISPLAY_PREVIEW = 2;
export const DISPLAY_STOCK_PREVIEW = 3;
export const ACCEPTED_IMAGE_TYPES = ['.jpg', '.jpeg', '.png'];



// WEBPACK FOOTER //
// ./src/common/Constants/imageUploader.js